import { render, staticRenderFns } from "./InjuryReportForm.vue?vue&type=template&id=0de03100&scoped=true&"
import script from "./InjuryReportForm.vue?vue&type=script&lang=ts&"
export * from "./InjuryReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./InjuryReportForm.vue?vue&type=style&index=0&id=0de03100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de03100",
  null
  
)

export default component.exports